/* Momeaze — mouse drag for the main product image slider (desktop) */
(function () {
  'use strict';
  if (window.MzGalleryDrag) return;
  window.MzGalleryDrag = true;

  var mq = window.matchMedia('(min-width: 750px)');
  var THRESHOLD = 6; // px before a press counts as a drag

  function init(list) {
    if (list.__mzDrag) return;
    list.__mzDrag = true;

    var down = false;
    var moved = false;
    var startX = 0;
    var startScroll = 0;

    list.addEventListener('dragstart', function (e) { e.preventDefault(); });

    list.addEventListener('mousedown', function (e) {
      if (e.button !== 0 || !mq.matches) return;
      if (e.target.closest('video, model-viewer, iframe, product-model')) return;
      down = true;
      moved = false;
      startX = e.clientX;
      startScroll = list.scrollLeft;
    });

    window.addEventListener('mousemove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (!moved) {
        if (Math.abs(dx) < THRESHOLD) return;
        moved = true;
        list.classList.add('mz-dragging');
        list.style.scrollSnapType = 'none';
        list.style.scrollBehavior = 'auto';
      }
      list.scrollLeft = startScroll - dx;
      e.preventDefault();
    });

    window.addEventListener('mouseup', function (e) {
      if (!down) return;
      down = false;
      if (!moved) return; // plain click -> zoom works as before

      var w = list.clientWidth || 1;
      var count = list.querySelectorAll('.product__media-item:not([hidden])').length;
      var idx = Math.round(startScroll / w);
      var dx = e.clientX - startX;
      if (Math.abs(dx) > w * 0.15) idx += dx < 0 ? 1 : -1;
      idx = Math.max(0, Math.min(count - 1, idx));

      list.classList.remove('mz-dragging');
      list.style.scrollSnapType = '';
      list.style.scrollBehavior = 'smooth';
      list.scrollTo({ left: idx * w });
      setTimeout(function () { list.style.scrollBehavior = ''; }, 500);

      // swallow the click that follows a drag so the zoom doesn't open
      list.__justDragged = true;
      setTimeout(function () { list.__justDragged = false; }, 60);
    });

    list.addEventListener(
      'click',
      function (e) {
        if (list.__justDragged) {
          e.preventDefault();
          e.stopPropagation();
        }
      },
      true
    );
  }

  function initAll() {
    document.querySelectorAll('media-gallery .product__media-list').forEach(init);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  window.addEventListener('load', initAll);
  // gallery can be re-rendered on variant change
  new MutationObserver(initAll).observe(document.documentElement, { childList: true, subtree: true });
})();